import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import LayoutDashboard from "../layout/layout";
import Login from "../pages/Auth/login/login";
import PrivateRoute from "./private-route";

const Navigation = () => {
  const auth = useSelector((data) => data.userDataSlice.userData);

  return (
    <Routes>
      <Route 
        path="/login" 
        element={auth ? <Navigate to="/customers" replace /> : <Login />}
      ></Route>
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <LayoutDashboard />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default Navigation;
